"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _lotteryAssistant = require("@/api/lotteryAssistant");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LotteryAssistantReply',
  directives: {
    hasPermi: {
      inserted: function inserted(el, binding) {
        var value = binding.value;
        var hasPermission = (0, _permission.checkPermi)(value);
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      total: 0,
      recordList: [],
      queryParams: {
        page: 1,
        limit: 20,
        id: '',
        userName: '',
        temp: new Date().getTime()
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:draw:reply:list'])) {
      this.getList();
    } else {
      this.$message.error('对不起，您没有访问权限');
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getList: function getList() {
      var _this = this;
      if (!(0, _permission.checkPermi)(['platform:draw:reply:list'])) {
        this.$message.error('对不起，您没有访问权限');
        return;
      }
      this.loading = true;
      this.queryParams.temp = new Date().getTime();
      (0, _lotteryAssistant.drawReplyListApi)(this.queryParams).then(function (res) {
        _this.recordList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams = {
        page: 1,
        limit: 20,
        id: '',
        userName: '',
        temp: new Date().getTime()
      };
      this.handleQuery();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    handleAdd: function handleAdd() {
      this.$router.push({
        path: '/marketing/lottery-assistant/reply/createReply/add',
        query: {
          operate: 'add'
        }
      });
    },
    handleEdit: function handleEdit(row) {
      this.$router.push({
        path: '/marketing/lottery-assistant/reply/createReply/edit',
        query: {
          id: row.id,
          operate: 'edit'
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modalSure('确定要删除该中奖名单吗？').then(function () {
        (0, _lotteryAssistant.drawReplyDeleteApi)(row.id).then(function () {
          _this2.$message.success('删除成功');
          _this2.getList();
        });
      });
    },
    handleStatusChange: function handleStatusChange(row) {
      var _this3 = this;
      var text = row.isEnabled === true ? '启用' : '禁用';
      this.$modalSure("\u786E\u5B9A\u8981".concat(text, "\u8BE5\u4E2D\u5956\u540D\u5355\u5417\uFF1F")).then(function () {
        (0, _lotteryAssistant.drawReplyUpdateApi)({
          id: row.id,
          isEnabled: row.isEnabled,
          userName: row.userName,
          userAvatar: row.userAvatar,
          replyMsg: row.replyMsg,
          replyPic: row.replyPic
        }).then(function () {
          _this3.$message.success("".concat(text, "\u6210\u529F"));
          _this3.getList();
        }).catch(function () {
          row.isEnabled = !row.isEnabled;
        });
      }).catch(function () {
        row.isEnabled = !row.isEnabled;
      });
    }
  }
};